var DirectivesModule = /** @class */ (function () {
    function DirectivesModule() {
    }
    return DirectivesModule;
}());
export { DirectivesModule };
